var React = require('react');

function WLove14 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_67_529)","key":0},[React.createElement("path",{"d":"M1.24761 1.29161C2.91129 -0.430537 5.60848 -0.430537 7.27216 1.29161L7.5 1.52745C8.64918 5.47518 8.54317 9.65202 7.5 14L4.48781 10.8818L1.24778 7.52788C-0.415899 5.80574 -0.415899 3.01376 1.24761 1.29161Z","fill":"#B0ADB9","key":0}),React.createElement("path",{"d":"M13.7524 1.29161C12.0887 -0.430537 9.39152 -0.430537 7.72784 1.29161L7.5 1.52745V14L10.5122 10.8819L13.7522 7.52806C15.4159 5.80574 15.4159 3.01376 13.7524 1.29161Z","fill":"#C0BEC6","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_67_529"},React.createElement("rect",{"width":"15","height":"14","fill":"white"})))]);
}

WLove14.defaultProps = {"width":"15","height":"14","viewBox":"0 0 15 14","fill":"none"};

module.exports = WLove14;

WLove14.default = WLove14;
